import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
export default function TermsConditionsForm(props) {
  return (
    <div>
      <Box component="div" m={8} align="left">
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry. Lorem Ipsum has been the industry's standard dummy text ever
        since the 1500s, when an unknown printer took a galley of type and
        scrambled it to make a type specimen book. It has survived not only five
        centuries, but also the leap into electronic typesetting, remaining
        essentially unchanged. It was popularised in the 1960s with the release
        of Letraset sheets containing Lorem Ipsum passages, and more recently
        with desktop publishing software like Aldus PageMaker including versions
        of Lorem Ipsu
      </Box>
      {props.formik.touched.isTermChecked &&
      Boolean(props.formik.errors.isTermChecked) ? (
        <Alert severity="error">Please agree to the Terms & Conditions </Alert>
      ) : (
        ''
      )}
      <Typography variant="h6" align="center">
        Terms & Conditions
        <Checkbox
          name="isTermChecked"
          checked={props.formik.values.isTermChecked}
          onChange={props.formik.handleChange}
          onBlur={props.formik.handleBlur}
          inputProps={{ 'aria-label': 'primary checkbox' }}
        />
      </Typography>
    </div>
  );
}
